import utils from 'utils/lsp-utils-service';
import template from './rw-tracking-number.html';

class RwTrackingNumberController {
  $onInit() {
    this.getShippingPartnerLink = utils.getShippingPartnerLink;
  }
}

export default class RwTrackingNumberComponent {
  constructor() {
    this.template = template;
    this.controller = RwTrackingNumberController;
    this.bindings = {
      value: '@',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-tracking-number/rw-tracking-number-component.js